import styled from 'styled-components';
import BGBanner from '../../assests/images/bg-banner.webp';

export const DonationConfirmSection = styled.div`
   position: relative; 
   padding-top:93px;
   padding-bottom: 168px;
   background-image:url(${BGBanner});
   background-color: #dcf4f6;

   @media screen and (max-width:1199px) {
    padding-top: 199px;
    padding-bottom: 155px;
   }
   @media screen and (max-width:767px) {
    padding-top: 166px;
    padding-bottom: 130px;
  }
`;
export const DonationConfirmWrapper = styled.div`
    width:100%;
    text-align: center;
    .btn-outline-success {
        padding: 12px 73px !important;
    }  
  
`;
export const Title = styled.h1`
   color: #01606F;
   font-family: "Jost", sans-serif;
   font-size: 40px;
   font-weight: 700; 
   line-height: 30px; 
   margin-bottom: 30px;
   text-align:center; 
   margin-top: 30px;

   .orange {
        color: #F7931E;
   }

   @media screen and (max-width:1199px) {
    font-size: 36px;
    line-height: 40px;

    }

   @media screen and (max-width:991px) {
        font-size: 35px;
        line-height: 40px;
    }
   
   @media screen and (max-width:767px) { 
        font-size: 33px;
        line-height: 35px;
   }
   
   @media screen and (max-width:575px) {
        font-size: 30px;
        line-height: 35px;
    }
`;
export const ConfirmationCard=styled.div`
    width:60%;
    margin:0 auto 28px auto;
    background: #EAF6F6;
    padding: 15px 18px;
    text-align:center;

    p {
        color: #555;
        font-size: 13px;
        line-height: 20px;
        margin-bottom: 10px; 
    }
`
export const H2 = styled.h2`
   color: #F7931E;
   font-family: "Jost", sans-serif;
   font-size: 24px;
   font-weight: normal; 
   line-height: 33px;
   margin-top: 5px;
   margin-bottom: 10px;
   text-align:center;

   @media screen and (max-width:1199px) {
    font-size: 36px;
    line-height: 40px;
    }

   @media screen and (max-width:991px) {
        font-size: 35px;
        line-height: 40px;
    }
   
   @media screen and (max-width:767px) { 
        font-size: 33px;
        line-height: 35px;
   }
   
   @media screen and (max-width:575px) {
        font-size: 30px;
        line-height: 35px;
    }
`;

export const ShareOnFacebook=styled.div`
    display: flex;
    justify-content: center;

    button {
        display: flex;
        font-size: 16px;
        padding: 8px 20px 8px 10px;
        border:none;
        width: auto;
        background: #466ca5;
        align-items: center;
        gap: 20px;
    }
    button:hover {
        background : #375581;
    }
`

export const Divider=styled.hr`
    width:60%;
    margin:20px auto;
`
export const NonprofitListItem=styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    width: 60%;

    button {
        border-radius: 4px !important;
        background: #fff;
        border: 1px solid #33A7AE;
        color: #33A7AE;
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        padding: 6px 9px;
        text-align: center;
    }
    button:hover{
        background: #33A7AE;
        color: #fff;
        border: 1px solid #33A7AE;
        text-decoration: none;
    }
`
export const NonprofitLink=styled.h4`
    color: #33A7AE;
    cursor: pointer;
`
export const LogoWrapper=styled.div`
    background: #01606F;
    max-width: 426px;
    margin: 0 auto;
    padding: 15px 0;
    border-radius: 5px;
       @media screen and (max-width:767px) {
          max-width: 297px;
       }
    img{
     @media screen and (max-width:767px) {
        width:100%;
        max-width:250px;
     }
    }


`